import React from "react";
import { withRouter } from "next/router";
import UseCases from "../src/pages/UseCases/UseCases";
import { NextSeo } from 'next-seo';
import { seoFunct } from '../src/config/next-seo.config';

const usecases = () => {
  return (
    <div>
      <NextSeo {...seoFunct("useCasesSeo")} />
      <UseCases />
    </div>
  );
};

export default withRouter(usecases);
